import React from "react";

interface StatusPillProps {
  variant?: "neutral" | "success" | "warning" | "info" | "danger";
  children: React.ReactNode;
}

const variantClasses: Record<NonNullable<StatusPillProps["variant"]>, string> = {
  neutral: "bg-gray-100 text-gray-700",
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  info: "bg-sky-50 text-sky-700",
  danger: "bg-red-50 text-red-700",
};

export const StatusPill: React.FC<StatusPillProps> = ({ variant = "neutral", children }) => (
  <span
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${variantClasses[variant]}`}
  >
    {children}
  </span>
);
